import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { DatePicker } from '@material-ui/pickers';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

const viewportWidth = window.innerWidth;
const datePickerScaleSize = viewportWidth / 458; // change the reference width as necessary

const styles = () => {
	return {
		scaleForMobile: {
			scale: datePickerScaleSize,
		},
	};
};

class FormDatePicker extends PureComponent {
	render() {
		const {
			label,
			value,
			path,
			onChange,
			required,
			error,
			helpText,
			disabled,
			gridProps,
			isYearPicker,
			format,
			readOnly,
			shouldScaleForMobile,
		} = this.props;

		const _onChange = (date) => {
			onChange(moment(date).format('YYYY-MM-DD'), path);
		};

		const hasError = !!error;
		const helperText = hasError ? error : helpText ? helpText : null;

		let content;
		if (isYearPicker) {
			content = (
				<DatePicker
					required={required}
					label={label}
					value={value || null}
					onChange={_onChange}
					animateYearScrolling
					format={format || 'M/D/YYYY'}
					disabled={disabled}
					error={hasError}
					fullWidth={true}
					margin={'dense'}
					helperText={helperText}
					disableFuture
					openTo="year"
					views={['year', 'month', 'day']}
					readOnly={readOnly}
				/>
			);
		} else {
			content = (
				<DatePicker
					required={required}
					label={label}
					value={value || null}
					showTodayButton
					onChange={_onChange}
					animateYearScrolling
					format={format || 'dddd, MMMM Do'}
					disabled={disabled}
					error={hasError}
					fullWidth={true}
					margin={'dense'}
					helperText={helperText}
					readOnly={readOnly}
					inputProps={{ variant: 'outlined' }}
					DialogProps={
						shouldScaleForMobile ? { className: this.props.classes.scaleForMobile } : undefined
					}
				/>
			);
		}

		if (gridProps) {
			_.defaults(gridProps, { xs: 12 });
			return (
				<Grid item {...gridProps}>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FormDatePicker.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	helpText: PropTypes.string,
	disabled: PropTypes.bool,
	isYearPicker: PropTypes.bool,
	required: PropTypes.bool,
	gridProps: PropTypes.object,
};

FormDatePicker.defaultProps = {
	isYearPicker: false,
	required: false,
};

export default _.flow([withStyles(styles)])(FormDatePicker);
